/**
 * @fileoverview Color Section Component
 *
 * Purpose: Group and display related colors with a section header
 * Used by: Component library color showcase
 */

interface ColorSectionProps {
  title: string;
  description?: string;
  children: React.ReactNode;
}

export function ColorSection({
  title,
  description,
  children,
}: ColorSectionProps) {
  return (
    <section className="space-y-6">
      <div className="space-y-2">
        <h2 className="text-2xl font-bold tracking-tight">{title}</h2>
        {description && (
          <p className="max-w-3xl text-muted-foreground">{description}</p>
        )}
      </div>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {children}
      </div>
    </section>
  );
}
